// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3NyPz","content":"styles_content__8nBJe","buttonTitle":"styles_buttonTitle__28a2x","buttonSubTitle":"styles_buttonSubTitle__2jygA"};